module.exports = __webpack_public_path__ + "img/site-logo.6ac25ac3.png";